const dataHoraAtualFormatada = (formato: string, separador:string) => {

    let data = new Date();
    if(!formato) formato = 'dia';
    if(!separador) separador = '/';

    let formattedDate = data.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('-').reverse().join(separador);

    if(formato === 'ano'){
        formattedDate = data.toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }

    const time = data.toLocaleTimeString('pt-BR', {hour: '2-digit',minute: '2-digit',second: '2-digit',hourCycle: 'h23' } );

    formattedDate = `${formattedDate} ${time}`;

    return formattedDate;
};

const dataHoraAtualMenosDiasFormatada = (formato: string, separador:string, qtdDias: number = 0) => {

    let data = new Date();
    var day = data.getDate() - qtdDias;
    data.setDate(day);

    if(!formato) formato = 'dia';
    if(!separador) separador = '/';

    let formattedDate = data.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('-').reverse().join(separador);

    if(formato === 'ano'){
        formattedDate = data.toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        let separadorReal = formattedDate.includes('/') ? '/' : '-';

        formattedDate = formattedDate.split(separadorReal).reverse().join(separador);
    }

    const time = data.toLocaleTimeString('pt-BR', {hour: '2-digit',minute: '2-digit',second: '2-digit',hourCycle: 'h23' } );

    formattedDate = `${formattedDate} ${time}`;

    return formattedDate;
};

const dataHoraAtualTruncOperacaoDiasFormatada = (formato: string, separador:string, qtdDias: number = 0, soma: Boolean = false) => {

    let data = new Date();
    var day = soma ? data.getDate() + qtdDias : data.getDate() - qtdDias;
    data.setDate(day);

    if(!formato) formato = 'dia';
    if(!separador) separador = '/';

    let formattedDate = data.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('-').reverse().join(separador);

    if(formato === 'ano'){
        formattedDate = data.toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        let separadorReal = formattedDate.includes('/') ? '/' : '-';

        formattedDate = formattedDate.split(separadorReal).reverse().join(separador);
    };

    formattedDate = `${formattedDate} 00:00:00`;

    return formattedDate;
};

const dataAtualFormatada = (formato: string, separador:string) => {

    let data = new Date();
    if(!formato) formato = 'dia';
    if(!separador) separador = '/';

    let dtRet = data.toLocaleDateString().split('/');

    //ano primeiro
    if(formato === 'ano') {
        return `${dtRet[2]}${separador}${dtRet[1]}${separador}${dtRet[0]}`
    }

    //dia primeiro
    return `${dtRet[0]}${separador}${dtRet[1]}${separador}${dtRet[2]}`

};

const horaAtualFormatada = () => {
    return new Date().toLocaleTimeString('pt-BR', {hour: '2-digit',minute: '2-digit',second: '2-digit',hourCycle: 'h23' } );
};

function dateTimeStringToISOFormat(dateTimeString:string, separador:string='/') {

    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dateTimeString.split(' ');

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split(separador);

    // Retornamos a data formatada em um padrão compatível com ISO:
    return `${YYYY}-${MM}-${DD}T${time}`;
}

    const validaExisteOMenu = (menu:any = null, urlMenu:string) => {

    if(!menu || !Array.isArray(menu) || (Array.isArray(menu) && menu?.length === 0) || !urlMenu) return false;
    const urlFiltrada = menu.filter(n => n.location === urlMenu);
    return urlFiltrada && Array.isArray(urlFiltrada) && urlFiltrada.length > 0;
};

const montaMenssagemRetornoErroPromiseAllSettled = (retorno:any = null, mensagemPadrao:string) => {
    let msg = retorno && retorno.reason && retorno.reason.response && retorno.reason.response.data && retorno.reason.response.data.msgs && Array.isArray(retorno.reason.response.data.msgs) ? retorno.reason.response.data.msgs[0] : null;
    msg = msg ? msg : retorno && retorno.reason && retorno.reason.message ? `Code ${retorno.reason.code} - ${retorno.reason.message}.` :  mensagemPadrao;
    return msg;
};

const xmontarMensagemTitleLink = (quantidadeAlerta: number = 0, abaQtdMaior: string, abaQtdMenor:string, qtdMaximaObjetosPendentesTela:number) => {
    return `Clique para acessar a aba ${abaQtdMenor} de tratamento dos pré-alertas pendentes.`;
}

export { dataAtualFormatada, dataHoraAtualFormatada, dataHoraAtualMenosDiasFormatada, dataHoraAtualTruncOperacaoDiasFormatada, dateTimeStringToISOFormat, horaAtualFormatada, validaExisteOMenu, montaMenssagemRetornoErroPromiseAllSettled, xmontarMensagemTitleLink };
